import { render } from "./OutsideBuildingView.vue?vue&type=template&id=b610c68c&scoped=true"
import script from "./OutsideBuildingView.vue?vue&type=script&lang=js"
export * from "./OutsideBuildingView.vue?vue&type=script&lang=js"

import "./OutsideBuildingView.vue?vue&type=style&index=0&id=b610c68c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b610c68c"]])

export default __exports__